import styles from './styles';
import { reFormat } from '../utils';

const DiseaseCell = ({ rowData, variant }) => {
    const classes = styles();
    let className = null;
    switch (variant) {
        case 'standard':
            className = classes.normalTextDivDark;
            break;
        case 'darkMode':
            className = classes.normalTextWhite;
            break;
        default:
            className = classes.normalTextDivDark;
    }
    return <div className={className}>{reFormat(rowData.disease)}</div>;
};

export default DiseaseCell;
